'use client';

import { cn } from '@/lib/utils/tw-merge';
import { useDictionary } from '@/components/providers';
import { useConsent } from './ConsentProvider';

type Props = {
    className?: string;
    /** Overrides the dictionary label; used where the surrounding copy differs. */
    children?: string;
};

export function CookieSettingsLink({ className, children }: Props) {
    const { openSettings } = useConsent();
    const { consent } = useDictionary();

    return (
        <button
            type="button"
            onClick={openSettings}
            className={cn('cursor-pointer text-sm text-copy-muted transition-colors hover:text-title-2', className)}
        >
            {children ?? consent.settingsLink}
        </button>
    );
}
